import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Form = styled('div')`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 20px;
`;

export const Message = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${theme.palette.secondary.main};
`;

export const DocumentsInfo = styled('div')`
  padding: 10px;
  background: ${theme.palette.brand.secondary};
  border-radius: 6px;
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  color: ${theme.palette.text.dark};
`;

export const Actions = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;

  .label {
    > svg {
      margin-left: 10px;
      margin-right: 0;
      width: 21px;
      height: 21px;
    }
  }
`;
